import React, { Fragment } from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../../components/_table/TableFilterInput';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';
import {
  INVALID_BULK_DELIVERY_DISPATCH_ORDER_ITEM_ID_CASE_TYPE_TEXT,
  INVALID_BULK_DELIVERY_DISPATCH_DELIVERY_TYPE_CASE_TYPE_TEXT,
  INVALID_BULK_DELIVERY_DISPATCH_DELIVERY_AGENT_NAME_CASE_TYPE_TEXT,
  INVALID_BULK_DELIVERY_DISPATCH_INVOICE_NUMBER_CASE_TYPE_TEXT,
  ORDER_DELIVERY_TYPE_TEXT,
} from '../../../../../constants/service/app/orderConstants';
import { setDash } from '../../../../../lib/common';

const columns = (data) => {
  const { filteredStoreId, filteredOrderItemId, filteredInvoiceNumber, onFilter } = data;

  return [
    {
      title: '순번',
      dataIndex: 'id',
      render: (value) => value,
    },
    {
      title: '가능여부',
      dataIndex: 'possibleCheck',
      render: (value, record) =>
        record.orderItemIdInvalidTypeList ||
        record.deliveryTypeInValidTypeList ||
        record.deliveryAgentNameInValidTypeList ||
        record.invoiceNumberInvalidTypeList
          ? 'X'
          : 'O',
    },
    {
      title: <TableColumnTitle title="브랜드 ID" filterValue={filteredStoreId} />,
      dataIndex: 'storeId',
      render: (value) => setDash(value),
      filterDropdown: ({ confirm, clearFilters }) => (
        <TableFilterInput
          placeholder="브랜드 ID 검색"
          option={filteredStoreId}
          confirm={confirm}
          clearFilters={clearFilters}
          onFilter={(storeId) => onFilter('storeId', 'filteredStoreId', storeId)}
        />
      ),
    },
    {
      title: <TableColumnTitle title="상품 주문 번호" filterValue={filteredOrderItemId} />,
      dataIndex: 'orderItemId',
      filterDropdown: ({ confirm, clearFilters }) => (
        <TableFilterInput
          placeholder="상품 주문 번호 검색"
          option={filteredOrderItemId}
          confirm={confirm}
          clearFilters={clearFilters}
          onFilter={(orderItemId) => onFilter('orderItemId', 'filteredOrderItemId', orderItemId)}
        />
      ),
      render: (value, record) => (
        <Fragment>
          {record.orderItemIdInvalidTypeList ? (
            setDash(value)
          ) : (
            <OpenOrderItemDetail text={value} orderItemId={value} />
          )}
          <div className="message">
            {record.orderItemIdInvalidTypeList && record.orderItemIdInvalidTypeList.length
              ? record.orderItemIdInvalidTypeList.map(
                  (invalidType) => INVALID_BULK_DELIVERY_DISPATCH_ORDER_ITEM_ID_CASE_TYPE_TEXT[invalidType],
                )
              : ''}
          </div>
        </Fragment>
      ),
    },
    {
      title: '배송방법',
      dataIndex: 'deliveryType',
      render: (value, record) => (
        <Fragment>
          {record.deliveryTypeInValidTypeList ? setDash(value) : setDash(ORDER_DELIVERY_TYPE_TEXT[value])}
          <div className="message">
            {record.deliveryTypeInValidTypeList && record.deliveryTypeInValidTypeList.length
              ? record.deliveryTypeInValidTypeList.map(
                  (invalidType) => INVALID_BULK_DELIVERY_DISPATCH_DELIVERY_TYPE_CASE_TYPE_TEXT[invalidType],
                )
              : ''}
          </div>
        </Fragment>
      ),
    },
    {
      title: '택배사',
      dataIndex: 'deliveryAgentName',
      render: (value, record) => (
        <Fragment>
          {setDash(value)}
          <div className="message">
            {record.deliveryAgentNameInValidTypeList && record.deliveryAgentNameInValidTypeList.length
              ? record.deliveryAgentNameInValidTypeList.map(
                  (invalidType) => INVALID_BULK_DELIVERY_DISPATCH_DELIVERY_AGENT_NAME_CASE_TYPE_TEXT[invalidType],
                )
              : ''}
          </div>
        </Fragment>
      ),
    },
    {
      title: <TableColumnTitle title="송장번호" filterValue={filteredInvoiceNumber} />,
      dataIndex: 'invoiceNumber',
      filterDropdown: ({ confirm, clearFilters }) => (
        <TableFilterInput
          placeholder="상품 주문 번호 검색"
          option={filteredOrderItemId}
          confirm={confirm}
          clearFilters={clearFilters}
          onFilter={(invoiceNumber) => onFilter('invoiceNumber', 'filteredInvoiceNumber', invoiceNumber)}
        />
      ),
      render: (value, record) => (
        <Fragment>
          {setDash(value)}
          <div className="message">
            {record.invoiceNumberInvalidTypeList && record.invoiceNumberInvalidTypeList.length
              ? record.invoiceNumberInvalidTypeList.map(
                  (invalidType) => INVALID_BULK_DELIVERY_DISPATCH_INVOICE_NUMBER_CASE_TYPE_TEXT[invalidType],
                )
              : ''}
          </div>
        </Fragment>
      ),
    },
  ];
};

export default columns;
